import { SITE_URL } from "@/seo/Seo";

export const PHONE = "+31659128521";

export const localBusinessLd = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#business`,
  name: "MyCleaner",
  description:
    "MyCleaner zet eigen, zorgvuldig gescreende schoonmakers in voor particulieren en bedrijven in de regio Amsterdam, Haarlem, Hoofddorp, Zaandam, Diemen, Weesp en Nieuw-Vennep.",
  url: SITE_URL,
  telephone: PHONE,
  priceRange: "€€",
  areaServed: [
    "Amsterdam", "Haarlem", "Hoofddorp", "Zaandam", "Diemen", "Weesp", "Nieuw-Vennep",
  ],
  address: {
    "@type": "PostalAddress",
    addressLocality: "Amsterdam",
    addressCountry: "NL",
  },
});

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

export const faqLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const serviceLd = (name, description, path) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  serviceType: name,
  provider: { "@type": "LocalBusiness", name: "MyCleaner", url: SITE_URL },
  areaServed: "Regio Amsterdam",
  url: `${SITE_URL}${path}`,
});

export const articleLd = (title, description, path) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: title,
  description,
  author: { "@type": "Organization", name: "MyCleaner" },
  publisher: { "@type": "Organization", name: "MyCleaner" },
  mainEntityOfPage: `${SITE_URL}${path}`,
});
